import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Timer } from '@alfa-bank/site-timer';
import { Case } from '@alfa-bank/site-content-switcher/case';
import { Switch } from '@alfa-bank/site-content-switcher/switch';
import { CountdownTimer } from '@alfa-bank/site-timer/countdown-timer';

import { TimerText as Component } from '../timer-text';
import type { TTimerText, IDepsDesktop } from '../models';
import styles from '../styles/styles.css';

export const TimerTextDesktop = createWidget<IDepsDesktop, TTimerText>({
    Case,
    Text,
    Switch,
    Timer,
    CountdownTimer,
    styles,
})(Component);
